// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"81":"dist/css/editor","442":"dist/css/t-home","469":"dist/css/t-projects","594":"dist/css/t-about","851":"dist/css/t-single-project","883":"dist/css/admin","921":"dist/css/main"}[chunkId] + ".css";
};